import React from "react";
import { Link } from "react-router-dom";

const InternalLinkButton = ({ options = {} }) => {
  const {
    icon_left,
    icon_right,
    main_btn_heading,
    main_btn_link,
    main_btn_container_classes = "",
    main_btn_classes = "",
  } = options;

  // Si no hay link válido, no renderizamos nada
  if (!main_btn_link) return null;

  return (
    <div className={main_btn_container_classes}>
      <Link
        to={`/${main_btn_link}`}
        className={`btn t-border-r05 ${main_btn_classes}`}
      >
        {icon_left?.icon && (
          <i className={`${icon_left.icon} t-mr-05`} aria-hidden="true" />
        )}

        <span>{main_btn_heading}</span>

        {icon_right?.icon && (
          <i className={`${icon_right.icon} t-pl-1`} aria-hidden="true" />
        )}
      </Link>
    </div>
  );
};

export default InternalLinkButton;
